import { useStore, TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';

import { RootState, store } from './store';

export type AppDispatch = typeof store.dispatch;
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
export const useAppStore = () => useStore<RootState>();
